module.exports = __webpack_public_path__ + "static/img/icon_interurbano.85316577.svg";